
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("i6rVm", function(module, exports) {

$parcel$export(module.exports, "maybe", function () { return (parcelRequire("6W4T8")).maybe; });
$parcel$export(module.exports, "invariant", function () { return (parcelRequire("belQy")).invariant; });
$parcel$export(module.exports, "newInvariantError", function () { return (parcelRequire("belQy")).newInvariantError; });

var $belQy = parcelRequire("belQy");

var $6W4T8 = parcelRequire("6W4T8");

var $kwEp5 = parcelRequire("kwEp5");
var $d2de72af8b3b81d0$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("belQy", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $82d1f2d11fbbf738$export$f5708dca728d7177; });
$parcel$export(module.exports, "newInvariantError", function () { return $82d1f2d11fbbf738$export$3991762405098ea; });

var $j4G6j = parcelRequire("j4G6j");

var $jO9rN = parcelRequire("jO9rN");

var $kwEp5 = parcelRequire("kwEp5");

var $9kfLk = parcelRequire("9kfLk");
function $82d1f2d11fbbf738$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $82d1f2d11fbbf738$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $82d1f2d11fbbf738$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $82d1f2d11fbbf738$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $j4G6j.invariant)(condition, $82d1f2d11fbbf738$var$getHandledErrorMsg(message, args) || $82d1f2d11fbbf738$var$getFallbackErrorMsg(message, args));
}, {
    debug: $82d1f2d11fbbf738$var$wrap((0, $j4G6j.invariant).debug),
    log: $82d1f2d11fbbf738$var$wrap((0, $j4G6j.invariant).log),
    warn: $82d1f2d11fbbf738$var$wrap((0, $j4G6j.invariant).warn),
    error: $82d1f2d11fbbf738$var$wrap((0, $j4G6j.invariant).error)
});
function $82d1f2d11fbbf738$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $j4G6j.InvariantError)($82d1f2d11fbbf738$var$getHandledErrorMsg(message, optionalParams) || $82d1f2d11fbbf738$var$getFallbackErrorMsg(message, optionalParams));
}
var $82d1f2d11fbbf738$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $jO9rN.version));
function $82d1f2d11fbbf738$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $9kfLk.stringifyForDisplay)(arg, 2).slice(0, 1000);
}
function $82d1f2d11fbbf738$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $kwEp5.default)[$82d1f2d11fbbf738$export$b8ca975fa04efdf3] && (0, $kwEp5.default)[$82d1f2d11fbbf738$export$b8ca975fa04efdf3](message, messageArgs.map($82d1f2d11fbbf738$var$stringify));
}
function $82d1f2d11fbbf738$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $jO9rN.version),
        message: message,
        args: messageArgs.map($82d1f2d11fbbf738$var$stringify)
    })));
}

});
parcelRegister("j4G6j", function(module, exports) {

$parcel$export(module.exports, "InvariantError", function () { return $de2f0c655e3e22fe$export$cea12affaee22fe8; });
$parcel$export(module.exports, "invariant", function () { return $de2f0c655e3e22fe$export$f5708dca728d7177; });

var $1rwT3 = parcelRequire("1rwT3");
var $de2f0c655e3e22fe$var$genericMessage = "Invariant Violation";
var $de2f0c655e3e22fe$var$_a = Object.setPrototypeOf, $de2f0c655e3e22fe$var$setPrototypeOf = $de2f0c655e3e22fe$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $de2f0c655e3e22fe$var$_a;
var $de2f0c655e3e22fe$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $1rwT3.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $de2f0c655e3e22fe$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $de2f0c655e3e22fe$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $de2f0c655e3e22fe$var$genericMessage;
        $de2f0c655e3e22fe$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $de2f0c655e3e22fe$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $de2f0c655e3e22fe$export$cea12affaee22fe8(message);
}
var $de2f0c655e3e22fe$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $de2f0c655e3e22fe$var$verbosityLevel = $de2f0c655e3e22fe$var$verbosityLevels.indexOf("log");
function $de2f0c655e3e22fe$var$wrapConsoleMethod(name) {
    return function() {
        if ($de2f0c655e3e22fe$var$verbosityLevels.indexOf(name) >= $de2f0c655e3e22fe$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $de2f0c655e3e22fe$var$wrapConsoleMethod("debug");
    invariant.log = $de2f0c655e3e22fe$var$wrapConsoleMethod("log");
    invariant.warn = $de2f0c655e3e22fe$var$wrapConsoleMethod("warn");
    invariant.error = $de2f0c655e3e22fe$var$wrapConsoleMethod("error");
})($de2f0c655e3e22fe$export$f5708dca728d7177 || ($de2f0c655e3e22fe$export$f5708dca728d7177 = {}));
function $de2f0c655e3e22fe$export$a80e09f2cd325fb8(level) {
    var old = $de2f0c655e3e22fe$var$verbosityLevels[$de2f0c655e3e22fe$var$verbosityLevel];
    $de2f0c655e3e22fe$var$verbosityLevel = Math.max(0, $de2f0c655e3e22fe$var$verbosityLevels.indexOf(level));
    return old;
}
var $de2f0c655e3e22fe$export$2e2bcd8739ae039 = $de2f0c655e3e22fe$export$f5708dca728d7177;

});

parcelRegister("jO9rN", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e6ba03df40aca1cd$export$83d89fbfd8236492; });
var $e6ba03df40aca1cd$export$83d89fbfd8236492 = "3.8.5";

});

parcelRegister("kwEp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef162319fe1ad6f5$export$2e2bcd8739ae039; });

var $6W4T8 = parcelRequire("6W4T8");
var $ef162319fe1ad6f5$export$2e2bcd8739ae039 = (0, $6W4T8.maybe)(function() {
    return globalThis;
}) || (0, $6W4T8.maybe)(function() {
    return window;
}) || (0, $6W4T8.maybe)(function() {
    return self;
}) || (0, $6W4T8.maybe)(function() {
    return $parcel$global;
}) || (0, $6W4T8.maybe)(function() {
    return (0, $6W4T8.maybe).constructor("return this")();
});

});
parcelRegister("6W4T8", function(module, exports) {

$parcel$export(module.exports, "maybe", function () { return $50cbf38cfa9a0510$export$f8b8b9ce72e9ccbf; });
function $50cbf38cfa9a0510$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("9kfLk", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", function () { return $6ca23560587f4574$export$f341b4883239463f; });

var $gdXr5 = parcelRequire("gdXr5");
function $6ca23560587f4574$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $gdXr5.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("gdXr5", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", function () { return $bcfbf6f2edd808bf$export$d0c8ec0fe1b18b70; });
var $bcfbf6f2edd808bf$var$prefixCounts = new Map();
function $bcfbf6f2edd808bf$export$d0c8ec0fe1b18b70(prefix) {
    var count = $bcfbf6f2edd808bf$var$prefixCounts.get(prefix) || 1;
    $bcfbf6f2edd808bf$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("k8Y7p", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", function () { return $eaa33047f477cd27$export$772fbc04a0ad4ce9; });
$parcel$export(module.exports, "canUseWeakSet", function () { return $eaa33047f477cd27$export$7293b8a0b474028d; });
$parcel$export(module.exports, "canUseSymbol", function () { return $eaa33047f477cd27$export$23ba675b4b838b92; });
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", function () { return $eaa33047f477cd27$export$c34f882e9f1c1637; });
$parcel$export(module.exports, "canUseLayoutEffect", function () { return $eaa33047f477cd27$export$4001f6cd4a62405b; });
parcelRequire("i6rVm");
var $6W4T8 = parcelRequire("6W4T8");
var $eaa33047f477cd27$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && (0, $6W4T8.maybe)(function() {
    return navigator.product;
}) !== "ReactNative";
var $eaa33047f477cd27$export$7293b8a0b474028d = typeof WeakSet === "function";
var $eaa33047f477cd27$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $eaa33047f477cd27$export$c34f882e9f1c1637 = $eaa33047f477cd27$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $eaa33047f477cd27$export$71594e8a50f746f4 = typeof (0, $6W4T8.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $eaa33047f477cd27$var$usingJSDOM = (0, $6W4T8.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $eaa33047f477cd27$export$4001f6cd4a62405b = $eaa33047f477cd27$export$71594e8a50f746f4 && !$eaa33047f477cd27$var$usingJSDOM;

});

parcelRegister("hWbmS", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", function () { return $d0f0abe37022a916$export$417207af72fad9c9; });
function $d0f0abe37022a916$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $d0f0abe37022a916$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});

parcelRegister("WKAhD", function(module, exports) {

$parcel$export(module.exports, "devAssert", function () { return $e3b9e6e307f65ef8$export$b6cb5906f04696c8; });
function $e3b9e6e307f65ef8$export$b6cb5906f04696c8(condition, message) {
    if (!condition) throw new Error(message);
}

});

parcelRegister("c4IG6", function(module, exports) {

$parcel$export(module.exports, "inspect", function () { return $0e5fc8d540e6718b$export$9dec5d1b3b6a130d; });
const $0e5fc8d540e6718b$var$MAX_ARRAY_LENGTH = 10;
const $0e5fc8d540e6718b$var$MAX_RECURSIVE_DEPTH = 2;
function $0e5fc8d540e6718b$export$9dec5d1b3b6a130d(value) {
    return $0e5fc8d540e6718b$var$formatValue(value, []);
}
function $0e5fc8d540e6718b$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $0e5fc8d540e6718b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0e5fc8d540e6718b$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($0e5fc8d540e6718b$var$isJSONable(value)) {
        const jsonValue = value.toJSON();
        // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $0e5fc8d540e6718b$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $0e5fc8d540e6718b$var$formatArray(value, seenValues);
    return $0e5fc8d540e6718b$var$formatObject(value, seenValues);
}
function $0e5fc8d540e6718b$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $0e5fc8d540e6718b$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $0e5fc8d540e6718b$var$MAX_RECURSIVE_DEPTH) return "[" + $0e5fc8d540e6718b$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $0e5fc8d540e6718b$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $0e5fc8d540e6718b$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $0e5fc8d540e6718b$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($0e5fc8d540e6718b$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($0e5fc8d540e6718b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $0e5fc8d540e6718b$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("7Cv8o", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $5937170d988c439f$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $5937170d988c439f$export$50792b0e93539fde; });
$parcel$export(module.exports, "QueryDocumentKeys", function () { return $5937170d988c439f$export$4fcd777a40ccf407; });
$parcel$export(module.exports, "isNode", function () { return $5937170d988c439f$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "OperationTypeNode", function () { return $5937170d988c439f$export$f58c50edb4aef9d4; });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $5937170d988c439f$export$18a2be9195644f38 {
    constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $5937170d988c439f$export$50792b0e93539fde {
    // eslint-disable-next-line max-params
    constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $5937170d988c439f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet",
        // Note: Client Controlled Nullability is experimental and may be changed
        // or removed in the future.
        "nullabilityAssertion"
    ],
    Argument: [
        "name",
        "value"
    ],
    // Note: Client Controlled Nullability is experimental and may be changed
    // or removed in the future.
    ListNullabilityOperator: [
        "nullabilityAssertion"
    ],
    NonNullAssertion: [
        "nullabilityAssertion"
    ],
    ErrorBoundary: [
        "nullabilityAssertion"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // Note: fragment variable definitions are deprecated and will removed in v17.0.0
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $5937170d988c439f$var$kindValues = new Set(Object.keys($5937170d988c439f$export$4fcd777a40ccf407));
function $5937170d988c439f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode?.kind;
    return typeof maybeKind === "string" && $5937170d988c439f$var$kindValues.has(maybeKind);
}
var $5937170d988c439f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($5937170d988c439f$export$f58c50edb4aef9d4 || ($5937170d988c439f$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("iE6bV", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $fc4e90fa71bf5448$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $fc4e90fa71bf5448$export$a84bdc57c5122798;
(function(Kind) {
    /** Name */ Kind["NAME"] = "Name";
    /** Document */ Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    /** Nullability Modifiers */ Kind["LIST_NULLABILITY_OPERATOR"] = "ListNullabilityOperator";
    Kind["NON_NULL_ASSERTION"] = "NonNullAssertion";
    Kind["ERROR_BOUNDARY"] = "ErrorBoundary";
    /** Fragments */ Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    /** Values */ Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    /** Directives */ Kind["DIRECTIVE"] = "Directive";
    /** Types */ Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    /** Type System Definitions */ Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    /** Type Definitions */ Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    /** Directive Definitions */ Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    /** Type System Extensions */ Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    /** Type Extensions */ Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($fc4e90fa71bf5448$export$a84bdc57c5122798 || ($fc4e90fa71bf5448$export$a84bdc57c5122798 = {}));

});

parcelRegister("kBJCe", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ERRORS_SYMBOL", function () { return $f00aa5a8d93ad65d$export$4995664c1b49842e; });
$parcel$export(module.exports, "graphQLResultHasProtocolErrors", function () { return $f00aa5a8d93ad65d$export$345f95cc6b6b9b0b; });
$parcel$export(module.exports, "isApolloError", function () { return $f00aa5a8d93ad65d$export$17f5e6bd290bb15d; });
$parcel$export(module.exports, "ApolloError", function () { return $f00aa5a8d93ad65d$export$26a337512320b8c6; });

var $1rwT3 = parcelRequire("1rwT3");
parcelRequire("i6rVm");

var $hWbmS = parcelRequire("hWbmS");
var $f00aa5a8d93ad65d$export$4995664c1b49842e = Symbol();
function $f00aa5a8d93ad65d$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$f00aa5a8d93ad65d$export$4995664c1b49842e]);
    return false;
}
function $f00aa5a8d93ad65d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var $f00aa5a8d93ad65d$var$generateErrorMessage = function(err) {
    var errors = (0, $1rwT3.__spreadArray)((0, $1rwT3.__spreadArray)((0, $1rwT3.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors.map(function(err) {
        return (0, $hWbmS.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $f00aa5a8d93ad65d$export$26a337512320b8c6 = function(_super) {
    (0, $1rwT3.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $f00aa5a8d93ad65d$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("iA0Ff", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", function () { return $e21764f8b0a28948$export$d5ee19b441e8d2ae; });
$parcel$export(module.exports, "printBlockString", function () { return $e21764f8b0a28948$export$adb6ca997eeb1f45; });

var $8ZCu2 = parcelRequire("8ZCu2");
function $e21764f8b0a28948$export$d5ee19b441e8d2ae(lines) {
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        const line = lines[i];
        const indent = $e21764f8b0a28948$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = firstNonEmptyLine ?? i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines// Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent))// Remove leading and trailing blank lines.
    .slice(firstNonEmptyLine ?? 0, lastNonEmptyLine + 1);
}
function $e21764f8b0a28948$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $8ZCu2.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $e21764f8b0a28948$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false; // Has non-printable characters
        case 0x000d:
            return false; // Has \r or \r\n which will be replaced as \n
        case 10:
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $e21764f8b0a28948$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""');
    // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1;
    // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $8ZCu2.isWhiteSpace)(line.charCodeAt(0)));
    // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""');
    // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !options?.minimize && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = "";
    // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $8ZCu2.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRegister("8ZCu2", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", function () { return $ba735ddf2f4e1669$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isDigit", function () { return $ba735ddf2f4e1669$export$727d9dbc4fbb948f; });
$parcel$export(module.exports, "isNameStart", function () { return $ba735ddf2f4e1669$export$45a677ea7cb6d5c8; });
$parcel$export(module.exports, "isNameContinue", function () { return $ba735ddf2f4e1669$export$d3f406ff46035894; });
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $ba735ddf2f4e1669$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $ba735ddf2f4e1669$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $ba735ddf2f4e1669$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $ba735ddf2f4e1669$export$45a677ea7cb6d5c8(code) {
    return $ba735ddf2f4e1669$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $ba735ddf2f4e1669$export$d3f406ff46035894(code) {
    return $ba735ddf2f4e1669$export$79c5d5217943d6a7(code) || $ba735ddf2f4e1669$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("7pBLZ", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $56582b258ea9beb9$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "default", function () { return $56582b258ea9beb9$export$2e2bcd8739ae039; });
const { toString: $56582b258ea9beb9$var$toString, hasOwnProperty: $56582b258ea9beb9$var$hasOwnProperty } = Object.prototype;
const $56582b258ea9beb9$var$fnToStr = Function.prototype.toString;
const $56582b258ea9beb9$var$previousComparisons = new Map();
function $56582b258ea9beb9$export$411ce8e5a71e3069(a, b) {
    try {
        return $56582b258ea9beb9$var$check(a, b);
    } finally{
        $56582b258ea9beb9$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$56582b258ea9beb9$export$2e2bcd8739ae039 = $56582b258ea9beb9$export$411ce8e5a71e3069;
function $56582b258ea9beb9$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $56582b258ea9beb9$var$toString.call(a);
    const bTag = $56582b258ea9beb9$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if ($56582b258ea9beb9$var$previouslyCompared(a, b)) return true;
                const aKeys = $56582b258ea9beb9$var$definedKeys(a);
                const bKeys = $56582b258ea9beb9$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$56582b258ea9beb9$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$56582b258ea9beb9$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if ($56582b258ea9beb9$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$56582b258ea9beb9$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = $56582b258ea9beb9$var$fnToStr.call(a);
                if (aCode !== $56582b258ea9beb9$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$56582b258ea9beb9$var$endsWith(aCode, $56582b258ea9beb9$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $56582b258ea9beb9$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($56582b258ea9beb9$var$isDefinedKey, obj);
}
function $56582b258ea9beb9$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $56582b258ea9beb9$var$nativeCodeSuffix = "{ [native code] }";
function $56582b258ea9beb9$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $56582b258ea9beb9$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $56582b258ea9beb9$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $56582b258ea9beb9$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("jHaP3", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $e56a6d947d4bdb6d$export$8e16b83750b44988; });
function $e56a6d947d4bdb6d$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});

parcelRegister("ggJzq", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", function () { return $bd817d4b74766b96$export$235b7fc70b9fc359; });

var $1rwT3 = parcelRequire("1rwT3");

var $jHaP3 = parcelRequire("jHaP3");
function $bd817d4b74766b96$export$235b7fc70b9fc359(defaults, options) {
    return (0, $jHaP3.compact)(defaults, options, options.variables && {
        variables: (0, $jHaP3.compact)((0, $1rwT3.__assign)((0, $1rwT3.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});

parcelRegister("9CClu", function(module, exports) {

$parcel$export(module.exports, "gql", function () { return $7015684ef38079b2$export$72e4926bf8358653; });
$parcel$export(module.exports, "default", function () { return $7015684ef38079b2$export$2e2bcd8739ae039; });

var $1rwT3 = parcelRequire("1rwT3");

var $dchi1 = parcelRequire("dchi1");
var $7015684ef38079b2$var$docCache = new Map();
var $7015684ef38079b2$var$fragmentSourceMap = new Map();
var $7015684ef38079b2$var$printFragmentWarnings = true;
var $7015684ef38079b2$var$experimentalFragmentVariables = false;
function $7015684ef38079b2$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $7015684ef38079b2$var$cacheKeyFromLoc(loc) {
    return $7015684ef38079b2$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $7015684ef38079b2$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $7015684ef38079b2$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $7015684ef38079b2$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($7015684ef38079b2$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $7015684ef38079b2$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $1rwT3.__assign)((0, $1rwT3.__assign)({}, ast), {
        definitions: definitions
    });
}
function $7015684ef38079b2$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $7015684ef38079b2$var$parseDocument(source) {
    var cacheKey = $7015684ef38079b2$var$normalize(source);
    if (!$7015684ef38079b2$var$docCache.has(cacheKey)) {
        var parsed = (0, $dchi1.parse)(source, {
            experimentalFragmentVariables: $7015684ef38079b2$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $7015684ef38079b2$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $7015684ef38079b2$var$docCache.set(cacheKey, $7015684ef38079b2$var$stripLoc($7015684ef38079b2$var$processFragments(parsed)));
    }
    return $7015684ef38079b2$var$docCache.get(cacheKey);
}
function $7015684ef38079b2$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $7015684ef38079b2$var$parseDocument(result);
}
function $7015684ef38079b2$export$657554ef4dc7ac2d() {
    $7015684ef38079b2$var$docCache.clear();
    $7015684ef38079b2$var$fragmentSourceMap.clear();
}
function $7015684ef38079b2$export$e4294e638636c6ab() {
    $7015684ef38079b2$var$printFragmentWarnings = false;
}
function $7015684ef38079b2$export$78cf889af350c840() {
    $7015684ef38079b2$var$experimentalFragmentVariables = true;
}
function $7015684ef38079b2$export$5290df9bbbd3cfa() {
    $7015684ef38079b2$var$experimentalFragmentVariables = false;
}
var $7015684ef38079b2$var$extras = {
    gql: $7015684ef38079b2$export$72e4926bf8358653,
    resetCaches: $7015684ef38079b2$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $7015684ef38079b2$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $7015684ef38079b2$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $7015684ef38079b2$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $7015684ef38079b2$var$extras.gql, gql_1.resetCaches = $7015684ef38079b2$var$extras.resetCaches, gql_1.disableFragmentWarnings = $7015684ef38079b2$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $7015684ef38079b2$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $7015684ef38079b2$var$extras.disableExperimentalFragmentVariables;
})($7015684ef38079b2$export$72e4926bf8358653 || ($7015684ef38079b2$export$72e4926bf8358653 = {}));
$7015684ef38079b2$export$72e4926bf8358653["default"] = $7015684ef38079b2$export$72e4926bf8358653;
var $7015684ef38079b2$export$2e2bcd8739ae039 = $7015684ef38079b2$export$72e4926bf8358653;

});
parcelRegister("dchi1", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d118c97a1b5d8087$export$98e6a39c04603d36; });

var $1IVEX = parcelRequire("1IVEX");

var $7Cv8o = parcelRequire("7Cv8o");

var $c5Gjp = parcelRequire("c5Gjp");

var $iE6bV = parcelRequire("iE6bV");

var $gap5p = parcelRequire("gap5p");

var $bYIyF = parcelRequire("bYIyF");

var $9cPwU = parcelRequire("9cPwU");
function $d118c97a1b5d8087$export$98e6a39c04603d36(source, options) {
    const parser = new $d118c97a1b5d8087$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d118c97a1b5d8087$export$5303528d1070ff6f(source, options) {
    const parser = new $d118c97a1b5d8087$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9cPwU.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $9cPwU.TokenKind).EOF);
    return value;
}
function $d118c97a1b5d8087$export$e14c466bd0916f7a(source, options) {
    const parser = new $d118c97a1b5d8087$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9cPwU.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $9cPwU.TokenKind).EOF);
    return value;
}
function $d118c97a1b5d8087$export$28b8f402ccc88182(source, options) {
    const parser = new $d118c97a1b5d8087$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9cPwU.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $9cPwU.TokenKind).EOF);
    return type;
}
class $d118c97a1b5d8087$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $bYIyF.isSource)(source) ? source : new (0, $bYIyF.Source)(source);
        this._lexer = new (0, $gap5p.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $9cPwU.TokenKind).NAME);
        return this.node(token, {
            kind: (0, $iE6bV.Kind).NAME,
            value: token.value
        });
    }
    // Implements the parsing rules in the Document section.
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).DOCUMENT,
            definitions: this.many((0, $9cPwU.TokenKind).SOF, this.parseDefinition, (0, $9cPwU.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $9cPwU.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $9cPwU.TokenKind).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $1IVEX.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    // Implements the parsing rules in the Operations section.
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $9cPwU.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, $iE6bV.Kind).OPERATION_DEFINITION,
            operation: (0, $7Cv8o.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $9cPwU.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $9cPwU.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $7Cv8o.OperationTypeNode).QUERY;
            case "mutation":
                return (0, $7Cv8o.OperationTypeNode).MUTATION;
            case "subscription":
                return (0, $7Cv8o.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $9cPwU.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $9cPwU.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $9cPwU.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $9cPwU.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $9cPwU.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, $iE6bV.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).SELECTION_SET,
            selections: this.many((0, $9cPwU.TokenKind).BRACE_L, this.parseSelection, (0, $9cPwU.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $9cPwU.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $iE6bV.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            // Experimental support for Client Controlled Nullability changes
            // the grammar of Field:
            nullabilityAssertion: this.parseNullabilityAssertion(),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $9cPwU.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    // TODO: add grammar comment after it finalizes
    parseNullabilityAssertion() {
        // Note: Client Controlled Nullability is experimental and may be changed or
        // removed in the future.
        if (this._options.experimentalClientControlledNullability !== true) return undefined;
        const start = this._lexer.token;
        let nullabilityAssertion;
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).BRACKET_L)) {
            const innerModifier = this.parseNullabilityAssertion();
            this.expectToken((0, $9cPwU.TokenKind).BRACKET_R);
            nullabilityAssertion = this.node(start, {
                kind: (0, $iE6bV.Kind).LIST_NULLABILITY_OPERATOR,
                nullabilityAssertion: innerModifier
            });
        }
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).BANG)) nullabilityAssertion = this.node(start, {
            kind: (0, $iE6bV.Kind).NON_NULL_ASSERTION,
            nullabilityAssertion: nullabilityAssertion
        });
        else if (this.expectOptionalToken((0, $9cPwU.TokenKind).QUESTION_MARK)) nullabilityAssertion = this.node(start, {
            kind: (0, $iE6bV.Kind).ERROR_BOUNDARY,
            nullabilityAssertion: nullabilityAssertion
        });
        return nullabilityAssertion;
    }
    parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $9cPwU.TokenKind).PAREN_L, item, (0, $9cPwU.TokenKind).PAREN_R);
    }
    parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9cPwU.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $iE6bV.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    // Implements the parsing rules in the Fragments section.
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $9cPwU.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $9cPwU.TokenKind).NAME)) return this.node(start, {
            kind: (0, $iE6bV.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment");
        // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $iE6bV.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $iE6bV.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $9cPwU.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $9cPwU.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $9cPwU.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $iE6bV.Kind).INT,
                    value: token.value
                });
            case (0, $9cPwU.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $iE6bV.Kind).FLOAT,
                    value: token.value
                });
            case (0, $9cPwU.TokenKind).STRING:
            case (0, $9cPwU.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $9cPwU.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $iE6bV.Kind).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $iE6bV.Kind).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $iE6bV.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $iE6bV.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, $9cPwU.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $9cPwU.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, $9cPwU.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $1IVEX.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $iE6bV.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $9cPwU.TokenKind).BLOCK_STRING
        });
    }
    parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).LIST,
            values: this.any((0, $9cPwU.TokenKind).BRACKET_L, item, (0, $9cPwU.TokenKind).BRACKET_R)
        });
    }
    parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).OBJECT,
            fields: this.any((0, $9cPwU.TokenKind).BRACE_L, item, (0, $9cPwU.TokenKind).BRACE_R)
        });
    }
    parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9cPwU.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $iE6bV.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $9cPwU.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $9cPwU.TokenKind).AT);
        return this.node(start, {
            kind: (0, $iE6bV.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    // Implements the parsing rules in the Types section.
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $9cPwU.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, $iE6bV.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).BANG)) return this.node(start, {
            kind: (0, $iE6bV.Kind).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $iE6bV.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    // Implements the parsing rules in the Type Definition section.
    peekDescription() {
        return this.peek((0, $9cPwU.TokenKind).STRING) || this.peek((0, $9cPwU.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $9cPwU.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $9cPwU.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, $iE6bV.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $9cPwU.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $9cPwU.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $9cPwU.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $9cPwU.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $9cPwU.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $9cPwU.TokenKind).PAREN_L, this.parseInputValueDef, (0, $9cPwU.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $9cPwU.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $9cPwU.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $9cPwU.TokenKind).EQUALS) ? this.delimitedMany((0, $9cPwU.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $9cPwU.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $9cPwU.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $1IVEX.syntaxError)(this._lexer.source, this._lexer.token.start, `${$d118c97a1b5d8087$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $9cPwU.TokenKind).BRACE_L, this.parseInputValueDef, (0, $9cPwU.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $9cPwU.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $9cPwU.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $9cPwU.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $9cPwU.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $iE6bV.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $9cPwU.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $c5Gjp.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    // Core parsing utility functions
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $7Cv8o.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $1IVEX.syntaxError)(this._lexer.source, token.start, `Expected ${$d118c97a1b5d8087$var$getTokenKindDesc(kind)}, found ${$d118c97a1b5d8087$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9cPwU.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, $1IVEX.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${$d118c97a1b5d8087$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9cPwU.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken ?? this._lexer.token;
        return (0, $1IVEX.syntaxError)(this._lexer.source, token.start, `Unexpected ${$d118c97a1b5d8087$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $9cPwU.TokenKind).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $1IVEX.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d118c97a1b5d8087$var$getTokenDesc(token) {
    const value = token.value;
    return $d118c97a1b5d8087$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d118c97a1b5d8087$var$getTokenKindDesc(kind) {
    return (0, $gap5p.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

});
parcelRegister("1IVEX", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $d082debd07616341$export$bbee0c6176c019d4; });

var $4yMwt = parcelRequire("4yMwt");
function $d082debd07616341$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $4yMwt.GraphQLError)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}

});
parcelRegister("4yMwt", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $4b9c0f3026ec62fc$export$92d6ed0888e7cb7f; });

var $6ZdEb = parcelRequire("6ZdEb");

var $fueMK = parcelRequire("fueMK");

var $bFAfT = parcelRequire("bFAfT");
class $4b9c0f3026ec62fc$export$92d6ed0888e7cb7f extends Error {
    constructor(message, options = {}){
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = options;
        super(message);
        this.name = "GraphQLError";
        this.path = path ?? undefined;
        this.originalError = originalError ?? undefined;
        // Compute list of blame nodes.
        this.nodes = $4b9c0f3026ec62fc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $4b9c0f3026ec62fc$var$undefinedIfEmpty(this.nodes?.map((node)=>node.loc).filter((loc)=>loc != null));
        // Compute locations in the source for the given nodes/positions.
        this.source = source ?? nodeLocations?.[0]?.source;
        this.positions = positions ?? nodeLocations?.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $fueMK.getLocation)(source, pos)) : nodeLocations?.map((loc)=>(0, $fueMK.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, $6ZdEb.isObjectLike)(originalError?.extensions) ? originalError?.extensions : undefined;
        this.extensions = extensions ?? originalExtensions ?? Object.create(null);
        // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        });
        // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError?.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $4b9c0f3026ec62fc$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $bFAfT.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $bFAfT.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $4b9c0f3026ec62fc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}

});
parcelRegister("6ZdEb", function(module, exports) {

$parcel$export(module.exports, "isObjectLike", function () { return $47bd5f3675b90c25$export$c10d0b04eaa80a43; });
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $47bd5f3675b90c25$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}

});

parcelRegister("fueMK", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $1c384d09693a6750$export$e7fd20fad3cf4b5f; });

var $fLnOu = parcelRequire("fLnOu");
const $1c384d09693a6750$var$LineRegExp = /\r\n|[\n\r]/g;
function $1c384d09693a6750$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($1c384d09693a6750$var$LineRegExp)){
        typeof match.index === "number" || (0, $fLnOu.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});
parcelRegister("fLnOu", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $e353bbc76f8299a5$export$f5708dca728d7177; });
function $e353bbc76f8299a5$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});


parcelRegister("bFAfT", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $228992035c90fe0c$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $228992035c90fe0c$export$867940333fd9f869; });

var $fueMK = parcelRequire("fueMK");
function $228992035c90fe0c$export$96a9681e539deed(location) {
    return $228992035c90fe0c$export$867940333fd9f869(location.source, (0, $fueMK.getLocation)(location.source, location.start));
}
function $228992035c90fe0c$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex];
    // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $228992035c90fe0c$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $228992035c90fe0c$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $228992035c90fe0c$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}

});



parcelRegister("c5Gjp", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $1bf90bf513dba8af$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $1bf90bf513dba8af$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    /** Request Definitions */ DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    /** Type System Definitions */ DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($1bf90bf513dba8af$export$b45ffd2948484c41 || ($1bf90bf513dba8af$export$b45ffd2948484c41 = {}));

});

parcelRegister("gap5p", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $6f98ac066a3b0c76$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $6f98ac066a3b0c76$export$59ac0f4da287406a; });

var $1IVEX = parcelRequire("1IVEX");

var $7Cv8o = parcelRequire("7Cv8o");

var $iA0Ff = parcelRequire("iA0Ff");

var $8ZCu2 = parcelRequire("8ZCu2");

var $9cPwU = parcelRequire("9cPwU");
class $6f98ac066a3b0c76$export$6168dc8908a6c652 {
    constructor(source){
        const startOfFileToken = new (0, $7Cv8o.Token)((0, $9cPwU.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $9cPwU.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $6f98ac066a3b0c76$var$readNextToken(this, token.end);
                // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken;
                // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $9cPwU.TokenKind).COMMENT);
        }
        return token;
    }
}
function $6f98ac066a3b0c76$export$59ac0f4da287406a(kind) {
    return kind === (0, $9cPwU.TokenKind).BANG || kind === (0, $9cPwU.TokenKind).QUESTION_MARK || kind === (0, $9cPwU.TokenKind).DOLLAR || kind === (0, $9cPwU.TokenKind).AMP || kind === (0, $9cPwU.TokenKind).PAREN_L || kind === (0, $9cPwU.TokenKind).PAREN_R || kind === (0, $9cPwU.TokenKind).SPREAD || kind === (0, $9cPwU.TokenKind).COLON || kind === (0, $9cPwU.TokenKind).EQUALS || kind === (0, $9cPwU.TokenKind).AT || kind === (0, $9cPwU.TokenKind).BRACKET_L || kind === (0, $9cPwU.TokenKind).BRACKET_R || kind === (0, $9cPwU.TokenKind).BRACE_L || kind === (0, $9cPwU.TokenKind).PIPE || kind === (0, $9cPwU.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $6f98ac066a3b0c76$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $6f98ac066a3b0c76$var$isSupplementaryCodePoint(body, location) {
    return $6f98ac066a3b0c76$var$isLeadingSurrogate(body.charCodeAt(location)) && $6f98ac066a3b0c76$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $6f98ac066a3b0c76$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $6f98ac066a3b0c76$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $6f98ac066a3b0c76$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $9cPwU.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    }
    // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $6f98ac066a3b0c76$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $7Cv8o.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $6f98ac066a3b0c76$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                return $6f98ac066a3b0c76$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BANG, position, position + 1);
            case 0x0024:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).AMP, position, position + 1);
            case 0x0028:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).COLON, position, position + 1);
            case 0x003d:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).AT, position, position + 1);
            case 0x005b:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BRACE_R, position, position + 1);
            case 0x003f:
                return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).QUESTION_MARK, position, position + 1);
            // StringValue
            case 0x0022:
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $6f98ac066a3b0c76$var$readBlockString(lexer, position);
                return $6f98ac066a3b0c76$var$readString(lexer, position);
        }
        // IntValue | FloatValue (Digit | -)
        if ((0, $8ZCu2.isDigit)(code) || code === 0x002d) return $6f98ac066a3b0c76$var$readNumber(lexer, position, code);
        // Name
        if ((0, $8ZCu2.isNameStart)(code)) return $6f98ac066a3b0c76$var$readName(lexer, position);
        throw (0, $1IVEX.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $6f98ac066a3b0c76$var$isUnicodeScalarValue(code) || $6f98ac066a3b0c76$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.`);
    }
    return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $6f98ac066a3b0c76$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
        // SourceCharacter
        if ($6f98ac066a3b0c76$var$isUnicodeScalarValue(code)) ++position;
        else if ($6f98ac066a3b0c76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $6f98ac066a3b0c76$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false;
    // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
    // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $8ZCu2.isDigit)(code)) throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $6f98ac066a3b0c76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    }
    // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $6f98ac066a3b0c76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    }
    // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position);
        // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $6f98ac066a3b0c76$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    }
    // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $8ZCu2.isNameStart)(code)) throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.`);
    return $6f98ac066a3b0c76$var$createToken(lexer, isFloat ? (0, $9cPwU.TokenKind).FLOAT : (0, $9cPwU.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $6f98ac066a3b0c76$var$readDigits(lexer, start, firstCode) {
    if (!(0, $8ZCu2.isDigit)(firstCode)) throw (0, $1IVEX.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $8ZCu2.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $6f98ac066a3b0c76$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).STRING, start, position + 1, value);
        }
        // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $6f98ac066a3b0c76$var$readEscapedUnicodeVariableWidth(lexer, position) : $6f98ac066a3b0c76$var$readEscapedUnicodeFixedWidth(lexer, position) : $6f98ac066a3b0c76$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        }
        // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
        // SourceCharacter
        if ($6f98ac066a3b0c76$var$isUnicodeScalarValue(code)) ++position;
        else if ($6f98ac066a3b0c76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid character within String: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $1IVEX.syntaxError)(lexer.source, position, "Unterminated string.");
}
function $6f98ac066a3b0c76$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3;
    // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++);
        // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$6f98ac066a3b0c76$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        }
        // Append this hex digit to the code point.
        point = point << 4 | $6f98ac066a3b0c76$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $6f98ac066a3b0c76$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $6f98ac066a3b0c76$var$read16BitHexCode(body, position + 2);
    if ($6f98ac066a3b0c76$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
    // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($6f98ac066a3b0c76$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $6f98ac066a3b0c76$var$read16BitHexCode(body, position + 8);
            if ($6f98ac066a3b0c76$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $6f98ac066a3b0c76$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $6f98ac066a3b0c76$var$readHexDigit(body.charCodeAt(position)) << 12 | $6f98ac066a3b0c76$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $6f98ac066a3b0c76$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $6f98ac066a3b0c76$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $6f98ac066a3b0c76$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $6f98ac066a3b0c76$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $6f98ac066a3b0c76$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).BLOCK_STRING, start, position + 3, // Return a string of the lines joined with U+000A.
            (0, $iA0Ff.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        }
        // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        }
        // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        }
        // SourceCharacter
        if ($6f98ac066a3b0c76$var$isUnicodeScalarValue(code)) ++position;
        else if ($6f98ac066a3b0c76$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $1IVEX.syntaxError)(lexer.source, position, `Invalid character within String: ${$6f98ac066a3b0c76$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $1IVEX.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $6f98ac066a3b0c76$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $8ZCu2.isNameContinue)(code)) ++position;
        else break;
    }
    return $6f98ac066a3b0c76$var$createToken(lexer, (0, $9cPwU.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRegister("9cPwU", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $79edc7f565b64e61$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $79edc7f565b64e61$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["QUESTION_MARK"] = "?";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($79edc7f565b64e61$export$8b9d26ab11394711 || ($79edc7f565b64e61$export$8b9d26ab11394711 = {}));

});


parcelRegister("bYIyF", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $7987e6065608ec1a$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $7987e6065608ec1a$export$75135ee9ed6e435b; });

var $WKAhD = parcelRequire("WKAhD");

var $g4XES = parcelRequire("g4XES");
class $7987e6065608ec1a$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $WKAhD.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $WKAhD.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $7987e6065608ec1a$export$75135ee9ed6e435b(source) {
    return (0, $g4XES.instanceOf)(source, $7987e6065608ec1a$export$1d2df86270c81ecb);
}

});
parcelRegister("g4XES", function(module, exports) {

$parcel$export(module.exports, "instanceOf", function () { return $fb660726a71d6ce6$export$ca03416d6c9e029e; });

var $c4IG6 = parcelRequire("c4IG6");
const $fb660726a71d6ce6$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process?.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in value ? value[Symbol.toStringTag] : value.constructor?.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $c4IG6.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

});





//# sourceMappingURL=Homepage.47857d96.js.map
